export const selectGraphicModal = ({ isMobile }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: isMobile ? "20px" : "40px",
});

export const modalHeader = () => ({
  maxWidth: "440px",
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  gap: "10px",
  color: "#fff",
});

export const modalTitle = ({ isMobile }) => ({
  fontFamily: "dinCondensed",
  fontSize: isMobile ? "40px" : "60px",
  lineHeight: isMobile ? "40px" : "60px",
  fontWeight: "700",
  letterSpacing: isMobile ? "0.4px" : "0.6px",
  textTransform: "uppercase",
});

export const modalText = ({ isMobile }) => ({
  fontSize: isMobile ? "16px" : "20px",
  lineHeight: "18px",
  letterSpacing: "0.7px",
  textTransform: "inherit",
});
export const modalDescription = ({ isMobile }) => ({
  fontSize: isMobile ? "14px" : "16px",
  lineHeight: "16px",
  letterSpacing: "1.2px",
  textTransform: "inherit",
});

export const contentContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: "center",
  gap: "20px",
});

export const contentCard = () => ({
  width: "330px",
  height: "280px",
  display: "flex",
  flexDirection: "column",
  outline: "1px solid #CCCCCC",
  borderRadius: "10px",
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.375)",
});

export const image = ({ backgroundImageUrl }) => ({
  height: "100%",
  backgroundImage: `url("${backgroundImageUrl}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  borderRadius: "10px 10px 0 0",
});

export const buttonContainer = {
  padding: "20px",
  display: "flex",
  justifyContent: "center",
  borderRadius: "0px 0px 10px 10px",
  backgroundColor: "white",
};
